export default "__VITE_ASSET__3bafd2a4__"